import React from 'react';
import DatePicker from '@techsoftware/happay-widgets/DatePicker';
import CutoffTimeIntimation from '../CutoffTimeIntimation';
import moment from 'moment';
import { invoiceScheduleAfterPaymentTime } from '../../../utils/common';

export default function RescheduleDatePicker({
  onChange,
  date,
  error = '',
  style = {},
  disabled,
  containerStyle = {},
  id = 'reschedule-payment',
}) {
  return (
    <div style={containerStyle} className="pos-relative">
      <DatePicker
        id={id}
        datePickerStyle={style}
        onChange={onChange}
        floatingLabelText="Payment Scheduled Date"
        value={date}
        fromdate={moment(new Date()).add(invoiceScheduleAfterPaymentTime() ? 1 : 0, 'days')}
        format="DD MMM YYYY"
        required
        disabled={disabled}
        disablePrevDates
        iconClass="primary-color"
        errorText={error}
        errorType={error && 'error'}
        disableToday
      />
      <div className="pos-absolute right-30 top-10 z-index-1">
        <CutoffTimeIntimation disabled={disabled} />
      </div>
    </div>
  );
}
